/* eslint-disable prettier/prettier */

const data: Record<string, string[]> = {
    "pyramid.static": [
        "/static/{0}/*subpath",
        "skey"
    ],
    "pyramid.asset.favicon": [
        "/favicon.ico"
    ],
    "pyramid.asset.css": [
        "/pyramid/css"
    ],
    "pyramid.asset.hlogo": [
        "/pyramid/mlogo"
    ],
    "pyramid.asset.blogo": [
        "/pyramid/blogo"
    ],
    "pyramid.openapi_json": [
        "/openapi.json"
    ],
    "pyramid.openapi_json_test": [
        "/test/openapi.json"
    ],
    "pyramid.swagger": [
        "/doc/api"
    ],
    "pyramid.control_panel": [
        "/control-panel"
    ],
    "pyramid.control_panel.sysinfo": [
        "/control-panel/sysinfo"
    ],
    "pyramid.control_panel.fonts": [
        "/control-panel/fonts"
    ],
    "pyramid.control_panel.backup.browse": [
        "/control-panel/backup/"
    ],
    "pyramid.control_panel.backup.download": [
        "/control-panel/backup/{0}",
        "filename"
    ],
    "pyramid.control_panel.cors": [
        "/control-panel/cors"
    ],
    "pyramid.control_panel.custom_css": [
        "/control-panel/custom-css"
    ],
    "pyramid.control_panel.logo": [
        "/control-panel/logo"
    ],
    "pyramid.control_panel.system_name": [
        "/control-panel/system-name"
    ],
    "pyramid.control_panel.home_path": [
        "/control-panel/home-path"
    ],
    "pyramid.control_panel.metrics": [
        "/control-panel/metrics"
    ],
    "pyramid.locale": [
        "/locale/{0}",
        "locale"
    ],
    "pyramid.test_request": [
        "/test/request/"
    ],
    "pyramid.test_exception_handled": [
        "/test/exception/handled"
    ],
    "pyramid.test_exception_unhandled": [
        "/test/exception/unhandled"
    ],
    "pyramid.test_exception_transaction": [
        "/test/exception/transaction"
    ],
    "pyramid.test_exception_template": [
        "/test/exception/template"
    ],
    "pyramid.test_timeout": [
        "/test/timeout"
    ],
    "pyramid.settings": [
        "/api/component/pyramid/settings"
    ],
    "pyramid.route": [
        "/api/component/pyramid/route"
    ],
    "pyramid.pkg_version": [
        "/api/component/pyramid/pkg_version"
    ],
    "pyramid.healthcheck": [
        "/api/component/pyramid/healthcheck"
    ],
    "pyramid.ping": [
        "/api/component/pyramid/ping"
    ],
    "pyramid.statistics": [
        "/api/component/pyramid/statistics"
    ],
    "pyramid.kind_of_data": [
        "/api/component/pyramid/kind_of_data"
    ],
    "pyramid.estimate_storage": [
        "/api/component/pyramid/storage/estimate"
    ],
    "pyramid.storage": [
        "/api/component/pyramid/storage"
    ],
    "pyramid.font": [
        "/api/component/pyramid/font"
    ],
    "pyramid.codegen_api_type": [
        "/api/component/pyramid/codegen/api_type"
    ],
    "pyramid.uacompat": [
        "/uacompat"
    ],
    "lunkwill.summary": [
        "/api/lunkwill/{0}/summary",
        "id"
    ],
    "lunkwill.response": [
        "/api/lunkwill/{0}/response",
        "id"
    ],
    "jsrealm.testentry": [
        "/testentry/*subpath"
    ],
    "auth.login": [
        "/login"
    ],
    "auth.session_invite": [
        "/session-invite"
    ],
    "auth.alink": [
        "/alink/{0}",
        "token"
    ],
    "auth.oauth": [
        "/oauth"
    ],
    "auth.logout": [
        "/logout"
    ],
    "auth.settings": [
        "/settings"
    ],
    "auth.user.browse": [
        "/auth/user/"
    ],
    "auth.user.create": [
        "/auth/user/create"
    ],
    "auth.user.edit": [
        "/auth/user/{0}",
        "id"
    ],
    "auth.group.browse": [
        "/auth/group/"
    ],
    "auth.group.create": [
        "/auth/group/create"
    ],
    "auth.group.edit": [
        "/auth/group/{0}",
        "id"
    ],
    "auth.user.collection": [
        "/api/component/auth/user/"
    ],
    "auth.user.item": [
        "/api/component/auth/user/{0}",
        "id"
    ],
    "auth.profile": [
        "/api/component/auth/profile"
    ],
    "auth.group.collection": [
        "/api/component/auth/group/"
    ],
    "auth.group.item": [
        "/api/component/auth/group/{0}",
        "id"
    ],
    "auth.current_user": [
        "/api/component/auth/current_user"
    ],
    "auth.login_cookies": [
        "/api/component/auth/login"
    ],
    "auth.logout_cookies": [
        "/api/component/auth/logout"
    ],
    "auth.permission": [
        "/api/component/auth/permission"
    ],
    "resource.schema": [
        "/resource/schema"
    ],
    "resource.root": [
        "/resource/"
    ],
    "resource.show": [
        "/resource/{0}",
        "id"
    ],
    "resource.json": [
        "/resource/{0}/json",
        "id"
    ],
    "resource.effective_permissions": [
        "/resource/{0}/permissions",
        "id"
    ],
    "resource.export.page": [
        "/resource/{0}/export",
        "id"
    ],
    "resource.control_panel.resource_export": [
        "/control-panel/resource-export"
    ],
    "resource.create": [
        "/resource/{0}/create",
        "id"
    ],
    "resource.update": [
        "/resource/{0}/update",
        "id"
    ],
    "resource.delete": [
        "/resource/{0}/delete",
        "id"
    ],
    "resource.favorite.page": [
        "/resource/favorite/"
    ],
    "resource.blueprint": [
        "/api/component/resource/blueprint"
    ],
    "resource.item": [
        "/api/resource/{0}",
        "id"
    ],
    "resource.collection": [
        "/api/resource/"
    ],
    "resource.items.delete": [
        "/api/resource/delete"
    ],
    "resource.permission": [
        "/api/resource/{0}/permission",
        "id"
    ],
    "resource.permission.explain": [
        "/api/resource/{0}/permission/explain",
        "id"
    ],
    "resource.volume": [
        "/api/resource/{0}/volume",
        "id"
    ],
    "resource.search": [
        "/api/resource/search/"
    ],
    "resource.quota_check": [
        "/api/component/resource/check_quota"
    ],
    "resource.favorite.schema": [
        "/api/component/resource/favorite/schema"
    ],
    "resource.favorite.collection": [
        "/api/component/resource/favorite/"
    ],
    "resource.favorite.item": [
        "/api/component/resource/favorite/{0}",
        "id"
    ],
    "resource.export": [
        "/api/resource/{0}/export",
        "id"
    ],
    "resource.file_download": [
        "/api/resource/{0}/file/{1}",
        "id",
        "name"
    ],
    "resource.widget": [
        "/api/resource/widget"
    ],
    "resource.preview": [
        "/api/resource/{0}/preview.png",
        "id"
    ],
    "file_upload.upload": [
        "/api/component/file_upload/upload"
    ],
    "file_upload.collection": [
        "/api/component/file_upload/"
    ],
    "file_upload.item": [
        "/api/component/file_upload/{0}",
        "id"
    ],
    "srs.browse": [
        "/srs/"
    ],
    "srs.create": [
        "/srs/create"
    ],
    "srs.edit": [
        "/srs/{0}",
        "id"
    ],
    "srs.catalog": [
        "/srs/catalog"
    ],
    "srs.catalog.import": [
        "/srs/catalog/{0}",
        "id"
    ],
    "spatial_ref_sys.collection": [
        "/api/component/spatial_ref_sys/"
    ],
    "spatial_ref_sys.convert": [
        "/api/component/spatial_ref_sys/convert"
    ],
    "spatial_ref_sys.geom_transform.batch": [
        "/api/component/spatial_ref_sys/geom_transform"
    ],
    "spatial_ref_sys.geom_transform": [
        "/api/component/spatial_ref_sys/{0}/geom_transform",
        "id"
    ],
    "spatial_ref_sys.geom_length": [
        "/api/component/spatial_ref_sys/{0}/geom_length",
        "id"
    ],
    "spatial_ref_sys.geom_area": [
        "/api/component/spatial_ref_sys/{0}/geom_area",
        "id"
    ],
    "spatial_ref_sys.item": [
        "/api/component/spatial_ref_sys/{0}",
        "id"
    ],
    "spatial_ref_sys.catalog.collection": [
        "/api/component/spatial_ref_sys/catalog/"
    ],
    "spatial_ref_sys.catalog.item": [
        "/api/component/spatial_ref_sys/catalog/{0}",
        "id"
    ],
    "spatial_ref_sys.catalog.import": [
        "/api/component/spatial_ref_sys/catalog/import"
    ],
    "layer.extent": [
        "/api/resource/{0}/extent",
        "id"
    ],
    "layer_preview.map": [
        "/resource/{0}/preview",
        "id"
    ],
    "feature_layer.export_multiple": [
        "/resource/export_multiple"
    ],
    "feature_layer.feature.browse": [
        "/resource/{0}/feature/",
        "id"
    ],
    "feature_layer.feature.show": [
        "/resource/{0}/feature/{1}",
        "id",
        "feature_id"
    ],
    "feature_layer.feature.update": [
        "/resource/{0}/feature/{1}/update",
        "id",
        "feature_id"
    ],
    "feature_layer.feature.item": [
        "/api/resource/{0}/feature/{1}",
        "id",
        "fid"
    ],
    "feature_layer.feature.geometry_info": [
        "/api/resource/{0}/feature/{1}/geometry_info",
        "id",
        "fid"
    ],
    "feature_layer.feature.collection": [
        "/api/resource/{0}/feature/",
        "id"
    ],
    "feature_layer.feature.count": [
        "/api/resource/{0}/feature_count",
        "id"
    ],
    "feature_layer.feature.extent": [
        "/api/resource/{0}/feature_extent",
        "id"
    ],
    "feature_layer.feature.item_extent": [
        "/api/resource/{0}/feature/{1}/extent",
        "id",
        "fid"
    ],
    "feature_layer.geojson": [
        "/api/resource/{0}/geojson",
        "id"
    ],
    "feature_layer.export": [
        "/api/component/feature_layer/export"
    ],
    "feature_layer.identify": [
        "/api/feature_layer/identify"
    ],
    "feature_layer.mvt": [
        "/api/component/feature_layer/mvt"
    ],
    "feature_layer.transaction.collection": [
        "/api/resource/{0}/feature/transaction/",
        "id"
    ],
    "feature_layer.transaction.item": [
        "/api/resource/{0}/feature/transaction/{1}",
        "id",
        "tid"
    ],
    "feature_layer.changes_check": [
        "/api/resource/{0}/feature/changes/check",
        "id"
    ],
    "feature_layer.changes_fetch": [
        "/api/resource/{0}/feature/changes/fetch",
        "id"
    ],
    "feature_layer.version.item": [
        "/api/resource/{0}/feature/version/{1}",
        "id",
        "vid"
    ],
    "feature_description.export": [
        "/api/resource/{0}/feature_description/export",
        "id"
    ],
    "feature_attachment.download": [
        "/api/resource/{0}/feature/{1}/attachment/{2}/download",
        "id",
        "fid",
        "aid"
    ],
    "feature_attachment.image": [
        "/api/resource/{0}/feature/{1}/attachment/{2}/image",
        "id",
        "fid",
        "aid"
    ],
    "feature_attachment.item": [
        "/api/resource/{0}/feature/{1}/attachment/{2}",
        "id",
        "fid",
        "aid"
    ],
    "feature_attachment.collection": [
        "/api/resource/{0}/feature/{1}/attachment/",
        "id",
        "fid"
    ],
    "feature_attachment.export": [
        "/api/resource/{0}/feature_attachment/export",
        "id"
    ],
    "feature_attachment.import": [
        "/api/resource/{0}/feature_attachment/import",
        "id"
    ],
    "feature_attachment.bundle": [
        "/api/component/feature_attachment/bundle"
    ],
    "feature_attachment.page": [
        "/resource/{0}/attachments",
        "id"
    ],
    "render.tile": [
        "/api/component/render/tile"
    ],
    "render.image": [
        "/api/component/render/image"
    ],
    "render.legend": [
        "/api/resource/{0}/legend",
        "id"
    ],
    "render.resource_legend_symbols": [
        "/api/component/render/legend_symbols"
    ],
    "render.legend_symbols": [
        "/api/resource/{0}/legend_symbols",
        "id"
    ],
    "webmap.annotation.collection": [
        "/api/resource/{0}/annotation/",
        "id"
    ],
    "webmap.annotation.item": [
        "/api/resource/{0}/annotation/{1}",
        "id",
        "annotation_id"
    ],
    "webmap.extent": [
        "/api/resource/{0}/webmap/extent",
        "id"
    ],
    "webmap.print": [
        "/api/component/{0}/webmap/print",
        "id"
    ],
    "webmap.display_config": [
        "/api/resource/{0}/webmap/display_config",
        "id"
    ],
    "webmap.display": [
        "/resource/{0}/display",
        "id"
    ],
    "webmap.display.tiny": [
        "/resource/{0}/display/tiny",
        "id"
    ],
    "webmap.clone": [
        "/resource/{0}/clone",
        "id"
    ],
    "webmap.preview_embedded": [
        "/webmap/embedded-preview"
    ],
    "webmap.control_panel.settings": [
        "/control-panel/webmap-settings"
    ],
    "vector_layer.inspect": [
        "/api/component/vector_layer/inspect"
    ],
    "postgis.connection.inspect": [
        "/api/resource/{0}/inspect/",
        "id"
    ],
    "postgis.connection.inspect.table": [
        "/api/resource/{0}/inspect/{1}/",
        "id",
        "table_name"
    ],
    "postgis.diagnostics": [
        "/api/component/postgis/check"
    ],
    "postgis.diagnostics_page": [
        "/resource/{0}/postgis-diagnostics",
        "id"
    ],
    "raster_layer.cog": [
        "/api/resource/{0}/cog",
        "id"
    ],
    "raster_layer.download": [
        "/api/resource/{0}/download",
        "id"
    ],
    "wfsserver.wfs": [
        "/api/resource/{0}/wfs",
        "id"
    ],
    "wfsclient.connection.inspect": [
        "/api/resource/{0}/wfsclient/inspect",
        "id"
    ],
    "wfsclient.connection.inspect.layer": [
        "/api/resource/{0}/wfsclient/inspect/{1}",
        "id",
        "layer"
    ],
    "wmsserver.wms": [
        "/api/resource/{0}/wms",
        "id"
    ],
    "ogcfserver.landing_page": [
        "/api/resource/{0}/ogcf",
        "id"
    ],
    "ogcfserver.openapi": [
        "/api/resource/{0}/ogcf/openapi",
        "id"
    ],
    "ogcfserver.conformance": [
        "/api/resource/{0}/ogcf/conformance",
        "id"
    ],
    "ogcfserver.collections": [
        "/api/resource/{0}/ogcf/collections",
        "id"
    ],
    "ogcfserver.collection": [
        "/api/resource/{0}/ogcf/collections/{1}",
        "id",
        "collection_id"
    ],
    "ogcfserver.items": [
        "/api/resource/{0}/ogcf/collections/{1}/items",
        "id",
        "collection_id"
    ],
    "ogcfserver.item": [
        "/api/resource/{0}/ogcf/collections/{1}/items/{2}",
        "id",
        "collection_id",
        "item_id"
    ],
    "tmsclient.connection.inspect": [
        "/api/resource/{0}/tmsclient/inspect",
        "id"
    ],
    "audit.dbase": [
        "/api/component/audit/dbase"
    ],
    "audit.control_panel.journal.browse": [
        "/control-panel/journal"
    ],
    "cadaster.enabled": [
        "/api/component/cadaster/enabled"
    ],
    "cadaster.pkk_by_position": [
        "/api/component/cadaster/request/by-position"
    ],
    "cadaster.pkk_by_id": [
        "/api/component/cadaster/request/by-id"
    ],
    "pyramid.control_panel.cadaster": [
        "/control-panel/cadaster"
    ],
    "collector.user.browse": [
        "/collector/view/user/"
    ],
    "collector.user.create": [
        "/collector/view/user/create"
    ],
    "collector.user.edit": [
        "/collector/view/user/{0}",
        "id"
    ],
    "collector.resource.users": [
        "/collector/resource/{0}/users",
        "id"
    ],
    "collector.resource.read": [
        "/collector/resource/{0}/read",
        "id"
    ],
    "collector.user.collection": [
        "/api/component/collector/user/"
    ],
    "collector.user.item": [
        "/api/component/collector/user/{0}",
        "user_id"
    ],
    "collector.user.limit": [
        "/api/component/collector/user/limit"
    ],
    "old.collector.user": [
        "/collector/user/{0}",
        "user_id"
    ],
    "old.collector.users": [
        "/collector/user"
    ],
    "formbuilder.formbuilder_form_ngfp": [
        "/api/resource/{0}/ngfp",
        "id"
    ],
    "qgis.style_qml": [
        "/api/resource/{0}/qml",
        "id"
    ],
    "terrain_provider.layer": [
        "/api/resource/{0}/terrain_provider/layer.json",
        "id"
    ],
    "terrain_provider.tile": [
        "/api/resource/{0}/terrain_provider/{1}/{2}/{3}.terrain",
        "id",
        "z",
        "x",
        "y"
    ],
    "terrain_provider.test": [
        "/terrain_provider/test"
    ],
    "model_3d.file_glb": [
        "/api/component/model_3d/{0}/data.glb",
        "id"
    ],
    "model_3d.refs.types": [
        "/api/component/style_3d/refs/types"
    ],
    "model_3d.refs.source_types": [
        "/api/component/style_3d/refs/source-types"
    ],
    "scene_3d.display": [
        "/3d-scene/{0}/display",
        "id"
    ],
    "tileset_3d.export": [
        "/api/resource/{0}/tileset_3d/export",
        "id"
    ],
    "pyramid.control_panel.tracker": [
        "/control-panel/tracker"
    ],
    "tracker.reports": [
        "/tracker/reports/"
    ],
    "tracker.reports.build": [
        "/tracker/report/build/"
    ],
    "tracker.receive_packet": [
        "/api/component/tracker/{0}/receive",
        "unique_id"
    ],
    "tracker.get_trackers": [
        "/api/component/tracker/trackers"
    ],
    "tracker.get_tracker_points": [
        "/api/component/tracker/points"
    ],
    "tracker.get_short_tracks": [
        "/api/component/tracker/tracks/short"
    ],
    "tracker.get_full_tracks": [
        "/api/component/tracker/tracks/full"
    ],
    "tracker.get_tracker_last_points": [
        "/api/component/tracker/last/points"
    ],
    "tracker.get_tracker_lines": [
        "/api/component/tracker/lines"
    ],
    "tracker.get_last_activity_tracker": [
        "/api/component/tracker/activity/last"
    ],
    "tracker.get_stops": [
        "/api/component/tracker/stops"
    ],
    "tracker.get_device_types": [
        "/api/component/tracker/device_types"
    ],
    "tracker.export_to_gpx": [
        "/api/tracker/gpx"
    ],
    "pyramid.csettings": [
        "/api/component/pyramid/csettings"
    ]
};
export default data;
